var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{style:({
            "min-width": "100%",
            "min-height": "100%",
            "background-image":"url("+_vm.$url+"/images/logo-sntss-bg.png"+")",
            "background-repeat":"repeat"
        })},[(_vm.$store.state.security.username)?_c('encabezado-main'):_vm._e(),_c('login-window'),_c('v-main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }